//* Libriries imports
import { z } from "zod";

export const documentosTiposSchema = z.enum([
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "historico_escolar",
  "declaracao_instituicao_superior",
  "comprovacao_concurso",
  "resultado_final_individual_sisu",
  "edital_calendario_matricula_ies",
  "resultado_final_individual_prouni_fies",
  "comprovante_vestibular",
  "comprovante_aprovacao",
  "comprovacao_estagio_jovem_aprendiz",
  "comprovacao_emprego_privado",
  "laudo_medico",
  "comprovante_exames_anteriores",
]);

export const documentosComunsSchema = z.enum([
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
]);

export type DocumentoTipo = z.infer<typeof documentosTiposSchema>;

export const DOCUMENTOS_ARTIGO_4 = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "historico_escolar",
  "declaracao_instituicao_superior",
] as const;

export const DOCUMENTOS_ARTIGO_5 = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "comprovacao_concurso",
] as const;

export type DocumentoArtigoQuatro = (typeof DOCUMENTOS_ARTIGO_4)[number];
export type DocumentoArtigoCinco = (typeof DOCUMENTOS_ARTIGO_5)[number];

export const DOCUMENTOS_SISU = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "historico_escolar",
  "declaracao_instituicao_superior",
  "resultado_final_individual_sisu",
  "edital_calendario_matricula_ies",
] as const;

export const DOCUMENTOS_PROUNI_FIES = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "historico_escolar",
  "declaracao_instituicao_superior",
  "resultado_final_individual_prouni_fies",
] as const;

export const DOCUMENTOS_FACULDADE_PRIVADA_ENEM = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "historico_escolar",
  "declaracao_instituicao_superior",
  "comprovante_vestibular",
  "comprovante_aprovacao",
] as const;

export const DOCUMENTOS_ESTAGIO_JOVEM_APRENDIZ = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "comprovacao_estagio_jovem_aprendiz",
] as const;

export const DOCUMENTOS_EMPREGO_PRIVADO = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "comprovacao_emprego_privado",
] as const;

export const DOCUMENTOS_CONCURSO = [
  "certidao_nascimento_ou_casamento",
  "rg_frente",
  "rg_verso",
  "cpf",
  "comprovacao_concurso",
] as const;
